export default {
  createANewRepair: "Create a new repair log",
  equipmentTag: "Equipment Tag",
  createdBy: "Created by",
  log: "Log",
  submit: "Submit"
};
